export default __webpack_public_path__ + "static/with-tablet-28873c6b0ecbe899c8f72132192d00e4.webp";